import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import About from "@/pages/About";
import Pricing from "@/pages/Pricing";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Login from "@/pages/Login";
import TrialRequest from "@/pages/TrialRequest";
import CompleteRegistration from "@/pages/CompleteRegistration";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import PatientKiosk from "@/pages/PatientKiosk";
import SuperDashboard from "@/pages/SuperDashboard";
import TabletLogin from "@/pages/TabletLogin";
import PatientStart from "@/pages/PatientStart";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";
import Impressum from "@/pages/Impressum";
import DirectRegister from "@/pages/DirectRegister";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/ueber-uns" element={<About />} />
          <Route path="/preise" element={<Pricing />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/registrieren-kaufen" element={<DirectRegister />} />
          <Route path="/bezahlen" element={<Checkout />} />
          <Route path="/bezahlung/erfolg" element={<PaymentSuccess />} />
          <Route path="/login" element={<Login />} />
          <Route path="/tablet" element={<TabletLogin />} />
          <Route path="/p/:code" element={<PatientStart />} />
          <Route path="/testzugang" element={<TrialRequest />} />
          <Route path="/register" element={<Navigate to="/testzugang" replace />} />
          <Route path="/registrieren" element={<CompleteRegistration />} />
          <Route path="/passwort-vergessen" element={<ForgotPassword />} />
          <Route path="/passwort-zuruecksetzen" element={<ResetPassword />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/patient" element={<PatientKiosk />} />
          <Route path="/super" element={<SuperDashboard />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
